
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateBusinessunitDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(45)]),
    shortname: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    active: new FormControl<boolean | undefined>(true),
    street: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    zipcode: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    city: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    canton: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    phoneCompany: new FormControl<string | undefined>(undefined, [Validators.maxLength(45)]),
    publicName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    description: new FormControl<string | undefined>(undefined),
    publicImageUrl: new FormControl<string | undefined>(undefined),
})
;
}
      